import moment from "moment";
import { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { Line } from 'react-chartjs-2';
import { Link } from "react-router-dom";
import { SnaphotApi as SnaphotApiDev } from '../services/akfenservices/api';
import { SnaphotApi as SnaphotApiProd } from '../services/akfenservicesprod/api';
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import CalendarComponent from "../components/_Helper/Calendar/calendar";
import * as $ from "jquery";
import 'chart.js/auto';
import 'chartjs-adapter-date-fns';

function Snapshot() {
  //#region API
  const snaphotApi = new SnaphotApiDev({
    username: 'akfeninsaat-avocet',
    password: 'G*W8Cc/k?zK&Pp9'
  });

  const snaphotProdApi = new SnaphotApiProd({
    username: 'akfeninsaat-avocet',
    password: 'G*W8Cc/k?zK&Pp9'
  });

  //#endregion

  //#region Page Property
  const { t, i18n } = useTranslation();
  const chartRef = useRef();
  //#endregion

  //#region UseState
  const [date, setDate] = useState(moment(new Date()).format("DD.MM.YYYY"));
  const [frequency, setFrequency] = useState("1y");
  const [chartStatu, setChartStatu] = useState(true);
  const [indexData, setIndexData] = useState([]);
  const [priceGridData, setPriceGridData] = useState([]);
  const [selectedLang, setSelectedLang] = useState("");
  const [companyInformation, setCompanyInformation] = useState([]);
  const [servicesControl, setServicesControl] = useState();
  const [newsData, setNewsData] = useState([{ date: "test", name: "test1" }]);
  const [newsStatu, setNewsStatu] = useState(true);
  const [visible, setVisible] = useState(false);
  const [chartData, setChartData] = useState({
    datasets: [
      {
        fill: false,
        borderColor: '#193954',
        borderWidth: 1,
        pointRadius: 0,
      },
    ],
  });

  const [chartOptions, setChartOptions] = useState({
    plugins: {
      legend: {
        display: false,
      },
      tooltip: {
        intersect: false,
        mode: 'index',
      },
    },
    scales: {
      x: {
        type: 'time',
        distribution: 'linear',
        grid: {
          display: false,
        },
        ticks: {
          font: {
            color: '#000',
            size: 13,
          },
        },
        time: {
          unit: 'month',
        },
      },
      y: {
        grid: {
          color: "#E1E2E2",
        },
        ticks: {
          font: {
            color: '#000',
            size: 12,
          },
          padding: 15,
        },
        beginAtZero: true,
      },
    },
  });

  const [startDate, setStartDate] = useState(() => {
    let date = new Date();
    date.setMonth(date.getMonth() - 1);
    date.setHours(0, 0, 0, 0);
    return date;
  });
  const [endDate, setEndDate] = useState(
    new Date(new Date().setHours(0, 0, 0, 0))
  );

  //#endregion

  //#region Service Control
  let api = servicesControl !== undefined && servicesControl ? snaphotProdApi : snaphotApi;
  //#endregion

  //#region Change Date
  const startDateChange = (e) => {
    if (e > endDate) {
      setStartDate(endDate);
      setEndDate(e);
    } else setStartDate(e);
  };

  const endDateChange = (e) => {
    if (e < startDate) {
      setEndDate(startDate);
      setStartDate(e);
    } else setEndDate(e);
  };
  //#endregion

  //#region Footer Content
  const footerContent = (
    <div>
      <Button
        className="o-custom-button btn btn-secondary"
        onClick={() => setVisible(false)}
      >
        <i className="fas fa-times align-middle"></i> <span>{t("Close")}</span>
      </Button>
    </div>
  );
  //#endregion

  //#region Format Number
  const formatNumber = (number) => {
    return number.toLocaleString("en-US", {
      style: "decimal",
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
  };
  //#endregion

  //#region Frequencies 
  const frequencies = [
    { value: "1w", label: t("weekly") },
    { value: "1m", label: t("month") },
    { value: "3m", label: t("month") },
    { value: "6m", label: t("month") },
    { value: "1y", label: "1y" },
    { value: "2y", label: "2y" },
    { value: "3y", label: "3y" },
    { value: "5y", label: "5y" }
  ];
  //#endregion

  //#region Load Data
  const openNewsDetail = (item) => {
    if (api !== undefined && api !== "") {
      api.snaphotNewsDetailGet(item.id).then(response => {
        if (response.status === 200) {
          let datas = response.data;
          setVisible(true);

          setTimeout(() => {
            let content = datas["body"];
            var parser = new DOMParser();
            var htmlDoc = parser.parseFromString(content, "text/html");

            $(".fa-question-circle", htmlDoc).css("display", "none");
            $("iframe", htmlDoc).each(function (index, element) {
              var iframe = $(this)[index];

              var iframeSrc = $(iframe).attr("src");

              if (iframeSrc.indexOf("embed") == -1) {
                if (iframeSrc.indexOf("youtu.be") != -1) {
                  let youtubeSrcId =
                    iframeSrc.split("/")[iframeSrc.split("/").length - 1];

                  $(iframe).attr(
                    "src",
                    "https://www.youtube.com/embed/" + youtubeSrcId
                  );
                } else if (iframeSrc.indexOf("youtube.com") != -1) {
                  var youtubeParams = iframeSrc.split("?")[1];

                  var urlParams = new URLSearchParams(youtubeParams);
                  let youtubeSrcId = urlParams.get("v");

                  $(iframe).attr(
                    "src",
                    "https://www.youtube.com/embed/" + youtubeSrcId
                  );
                }
              }
            });

            var stringHtmlContent = $("body", htmlDoc).html();

            if (stringHtmlContent.substring(0, 5) == "<?xml") {
              $("#newsModalBody").append(stringHtmlContent.split("</head>")[1]);
              $("#newsModalBody .fa-question-circle").remove();
              $("#newsModalBody .gwt-Label").css("text-align", "left");
            } else {
              $("#newsModalBody").append(stringHtmlContent);
            }

            $("#newsModalHeader").html(item.header);
            $("#newsModalHeaderDate").html(moment.utc(item.date).local().format('MM/DD/YYYY HH:mm:ss'))
          }, 100);
        }
      })
    }
  };

  const indexCoverageInformation = () => {
    if (api !== undefined && api !== "") {
      api.snaphotIndexWeightGet("sec.101.84224", selectedLang).then(response => {
        console.log("res: ", response);
        if (response.status === 200) {
          let datas = response.data;
          setIndexData(datas);
        }
      })
    }
  };

  const priceChartData = (frequency) => {
    let fr = "OneYear";
    if (frequency !== undefined && frequency !== null && frequency !== "") {
      if (frequency === "1w") fr = "OneWeek"
      else if (frequency === "1m") fr = "OneMonth"
      else if (frequency === "3m") fr = "ThreeMonth"
      else if (frequency === "6m") fr = "SixMonth"
      else if (frequency === "1y") fr = "OneYear"
      else if (frequency === "2y") fr = "TwoYear"
      else if (frequency === "3y") fr = "ThreeYear"
      else if (frequency === "5y") fr = "FiveYear"
    }

    if (api !== undefined && api !== "") {
      api.snaphotPriceChartGet("sec.101.84224", fr).then(response => {
        if (response.status === 200) {
          let datas = response.data;
          let data1 = [];
          let label = [];

          for (var i = 0; i < datas.length; i++) {
            data1.push(parseFloat(datas[i]["value"]).toFixed(2));
            label.push(moment(new Date(datas[i]["date"].toString().split('T')[0])).format("yyyy-MM-DD"));
          }

          const newChartData = {
            labels: label,
            datasets: [
              {
                data: data1,
                fill: false,
                borderColor: '#193954',
                borderWidth: 1,
                pointRadius: 0,
              },
            ],
          };

          setChartData(newChartData);
          setPriceGridData(datas.reverse());
        }
      })
    }
  };

  const companyInfo = () => {
    if (api !== undefined && api !== "") {
      api.snaphotCardFieldsGet("sec.101.84224", selectedLang).then(response => {
        if (response.status === 200) {
          let datas = response.data;
          datas.map((item) => {
            if (item.id === "field.marketcaptl" || item.id === "field.marketcapusd") {
              item.value = parseFloat(item.value) / 1000000;
            }
          });
          if (selectedLang === "en-US") {
            datas.map((item) => {
              item.name = item.name.replace("TL", "TRY");
              item.name = item.name.replace("mn, TRY", "TRY, mn");
              item.name = item.name.replace("mn, USD", "USD, mn");
            })
          }
          else if (selectedLang === "tr-TR") {
            datas.map((item) => {
              item.name = item.name.replace("mln, TL", "TL, mln");
              item.name = item.name.replace("mln, USD", "USD, mln");
            })
          }
          // const fieldsToRemove = [
          //   "field.netdebtusd",
          //   "field.netdebttl",
          //   "field.enterprisevalueusd",
          //   "field.enterprisevaluetl",
          //   "field.averagevolume6mtlfreefloatmcap ",
          //   "field.averagevalue ",
          //   "field.averageprice1mtl"
          // ]
          // const filteredDatas = datas.filter(item => !fieldsToRemove.includes(item.id));
          const sortedDatas = datas.sort((a, b) => a.order - b.order);

          setCompanyInformation(sortedDatas);
        }
      })
    }
  };

  const newsDatas = () => {
    if (api !== undefined && api !== "") {
      let sDate = moment(startDate).format("yyyy-MM-DD");
      let eDate = moment(endDate).format("yyyy-MM-DD");

      api.snaphotNewsGet("sec.101.84224", selectedLang, sDate, eDate, 20, 0).then(response => {
        if (response.status === 200) {
          let datas = response.data;
          setNewsData(datas);
        }
      })
    }
  };
  //#endregion

  //#region Other Function
  const frequencyFunction = (e, fr) => {
    setFrequency(fr);

    let items = document.querySelectorAll("#chart-dates .list-inline-item");
    items.forEach((s) => {
      if (s.childNodes[0].classList.contains("selected")) {
        s.childNodes[0].classList.remove("selected");
      }
    });
    e.target.classList.add("selected");
  };

  const handlePage = () => {
    indexCoverageInformation();
    companyInfo();
  };
  //#endregion

  //#region UseEffect
  useEffect(() => {
    let control = typeof window.location !== 'undefined' &&
      window.location.origin.indexOf("localhost") !== -1 ?
      false :
      window.location.origin.indexOf("akfeninsaat-test.rasyonet") !== -1 ?
        false :
        window.location.origin.indexOf("akfeninsaat.rasyonet") !== -1 &&
        true;

    setServicesControl(control);

    if (window.location.pathname.indexOf("snapshot") !== -1) {
      i18n.changeLanguage("en");
      setDate(moment(new Date()).format("MM/DD/YYYY"));
      setSelectedLang("en-US");
      setNewsStatu(false);
    } else {
      setDate(moment(new Date()).format("MM/DD/YYYY"));
      setSelectedLang("tr-TR");
      setNewsStatu(true);
    }
  }, []);

  useEffect(() => {
    priceChartData(frequency);
  }, [frequency]);

  useEffect(() => {
    if (selectedLang !== "") {
      handlePage();

      setChartOptions({
        plugins: {
          legend: {
            display: false,
          },
          tooltip: {
            intersect: false,
            mode: 'index',
            callbacks: {
              label: (tooltipItem) => {
                if (selectedLang === 'tr-TR') {
                  return formatNumber(tooltipItem.raw, 2, selectedLang) + " TL";
                }
                else {
                  return formatNumber(tooltipItem.raw, 2, selectedLang) + " TRY";
                }
              },
              title: (tooltipItems) => {
                const date = new Date(tooltipItems[0].parsed.x);
                if (selectedLang === 'tr-TR') {
                  return new Intl.DateTimeFormat('tr-TR', {
                    year: 'numeric',
                    month: 'long',
                    day: 'numeric'
                  }).format(date);
                } else {
                  return new Intl.DateTimeFormat('en-US', {
                    year: 'numeric',
                    month: 'long',
                    day: 'numeric'
                  }).format(date);
                }
              },
            },
          },
        },
        scales: {
          x: {
            type: 'time',
            distribution: 'linear',
            grid: {
              display: false,
            },
            ticks: {
              callback: (value, index, ticks) => {
                const date = new Date(value);
                if (selectedLang === 'tr-TR') {
                  return new Intl.DateTimeFormat('tr-TR', {
                    year: 'numeric',
                    month: 'short'
                  }).format(date);
                } else {
                  return new Intl.DateTimeFormat('en-US', {
                    year: 'numeric',
                    month: 'short'
                  }).format(date);
                }
              },
              font: {
                color: '#000',
                size: 13,
              },
            },
            time: {
              unit: 'month'
            },
          },
          y: {
            grid: {
              color: "#E1E2E2",
            },
            ticks: {
              callback: function (value, index, ticks) {
                return formatNumber(value, 2, selectedLang);
              },
              font: {
                color: '#000',
                size: 12,
              },
              padding: 15,
            },
            beginAtZero: false,
          },
        },
      })
    }
  }, [selectedLang]);

  useEffect(() => {
    if (
      selectedLang != "" &&
      startDate !== undefined &&
      endDate !== undefined
    ) {
      newsDatas();
    }
  }, [startDate, endDate, selectedLang]);

  //#endregion

  return (
    <>
      <div className="container-fluid mt-4">
        <div className="header mb-4">{t("headerTitle")}</div>

        <div className="row mb-4">
          <div className="col-6">
            <div className="title mb-4">
              {t("pricePerformance")}
              <i
                className="fa fa-th float-end"
                onClick={() => setChartStatu(!chartStatu)}
              ></i>
            </div>
            <div className={`row ${chartStatu ? "" : "d-none"}`}>
              <div className="col-md-12 text-end rt-item">
                <ul id="chart-dates" className="list-inline m-0 chart-period-btn mb-3">
                  {frequencies.map(({ value, label }) => (
                    <li key={value} className="list-inline-item" onClick={(e) => frequencyFunction(e, value)}>
                      <Link data-date={value} className={`btn btn-block ${value === "1y" ? "selected" : ""}`}>
                        {value === "1y" ? "1y" : value === "2y" ? "2y" : value === "3y" ? "3y" : value === "5y" ? "5y" : `${value.charAt(0)}${label}`}
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>
              <div style={{ width: '100%', height: '100%' }} className=" d-block">
                <Line ref={chartRef} data={chartData} options={chartOptions} />
              </div>
            </div>
            <div className={`row ${chartStatu ? "d-none" : ""}`}>
              <div className="col-md-12">
                <div className="gridTable mb-3">
                  <table className="grid w-100">
                    <thead>
                      <tr>
                        <th>{t("date")}</th>
                        <th>{t("data")}</th>
                      </tr>
                    </thead>
                    <tbody>
                      {priceGridData?.map((item, index) => (
                        <tr key={index}>
                          <td>{moment(item.date).format("DD.MM.yyyy")}</td>
                          <td>{formatNumber(parseFloat(item.value))}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
          <div className="col-6">
            <div className="title">
              {t("companyInformation")}
              <span className="date float-end spacing-0">{moment(date).format("DD.MM.yyyy")}</span>
            </div>
            <table className="compancyCard w-100">
              {companyInformation !== undefined && companyInformation.length > 0 &&
                <tbody>
                   <tr>
                      <td>{selectedLang === "en-US" ? "Sector" : "Sektör"}</td>
                      <td>{selectedLang === "en-US" ? "Construction" : "İnşaat"}</td>
                    </tr>
                  <tr>
                    <td>{selectedLang === "en-US" ? "Ticker" : "Borsa Kodu"}</td>
                    <td>AKFIS</td>
                  </tr>
                  {companyInformation.map((item, key) => (
                    <tr key={key}>
                      <td>{selectedLang === "en-US" ? item.name.replace("TL", "TRY") : item.name}</td>
                      <td className="table-value">{formatNumber(parseFloat(item.value))}</td>
                    </tr>
                  ))}
                </tbody>
              }
            </table>
          </div>
        </div>

        <div className={`row mb-5 ${newsStatu ? "" : "d-none"}`}>
          <div className="col-md-12">
            <div className="title mb-3">{t("kapNews")}</div>
            <div className="dateArea mb-3">
              <div className="firstDate d-inline-block me-3">
                <CalendarComponent date={startDate} change={startDateChange} />
              </div>
              <div className="lastDate d-inline-block">
                <CalendarComponent date={endDate} change={endDateChange} />
              </div>
            </div>
            <div className="news d-inline-block position-relative w-100">
              <table className="w-100">
                <tbody>
                  {newsData?.map((item, index) => (
                    <tr
                      key={index}
                      onClick={() => {
                        openNewsDetail(item);
                      }}
                    >
                      <td>{moment(item.date).format("DD.MM.yyyy hh:mm:ss")}</td>
                      <td>{item.header}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>

        <div className="row mb-3 mt-3">
          <div className="col-md-12">
            <div className="title mb-3">{t("indexCoverage")}</div>
            <div className="indexWeightTable d-inline-block position-relative w-100">
              <table className="indexWeight w-100">
                <thead>
                  <tr>
                    <th>{t("index")}</th>
                    <th>{t("weight")}</th>
                  </tr>
                </thead>
                <tbody>
                  {indexData?.map((item, index) => (
                    <tr key={index}>
                      <td>{item.name}</td>
                      <td className="table-value">{formatNumber(parseFloat(item.value))}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>

        <div className="note text-end d-inline-block w-100">{t("note")}</div>
        <div className="note text-end d-inline-block w-100">
          {t("noteSnapshot")}
        </div>
      </div>

      <Dialog
        header="Haber Detayı"
        visible={visible}
        style={{ width: "50vw" }}
        onHide={() => setVisible(false)}
        footer={footerContent}
      >
        <div id="newsModalHeader" className="mb-2"></div>
        <div id="newsModalHeaderDate" className="mb-3"></div>
        <div id="newsModalHeaderProvider"></div>

        <div className="col-md-12" id="newsModalScrollDiv">
          <div id="newsModalBody" className=""></div>
        </div>
      </Dialog>

    </>
  );
}

export default Snapshot;
